import { IonContent, IonPage, IonCol, IonRow, IonGrid, IonButton, IonIcon, IonTextarea, IonFooter, useIonViewDidEnter, IonToast, useIonAlert, IonPopover, IonList, IonItem, IonLabel } from '@ionic/react';
import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import './FellowshipCommentsPage.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import { chatboxEllipses, ellipsisVertical, send, trashBin } from 'ionicons/icons';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { SelectGroupMembers, SelectPost, SelectPosts, UpdatePosts } from '../../store/FellowshipSlice';
import ServerDBContext from '../../components/ServerDBContext/ServerDBContext';
import IFellowshipPost from '../../interfaces/IFellowshipPost';
import IFellowshipComment from '../../interfaces/IFellowshipComment';
import { SelectCurrentUser, SelectNetworkConnected } from '../../store/UserSlice';
import PostTypes, { PostTypesValues } from '../../data/PostTypes';
import { GetMemberInfo } from '../../interfaces/IGroupMembers';
import NetworkNotification from '../../components/NetworkNotification/NetworkNotification';
import PostVideos from '../../components/PostVideos/PostVideos';
import UserRoles from '../../data/UserRoles';
import FellowshipPostService from '../../services/FellowshipPostService';
import DateHelperService from '../../services/DateHelperService';
import { AppRouteInfo, AppRouteKeys } from '../../routes/AppRoutes';

const FellowshipCommentsPage: React.FC<IRouteInfo> = (props: IRouteInfo) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const dbService = useContext(ServerDBContext);
  const memberDetails =  useSelector(SelectGroupMembers);
  const currentUser = useSelector(SelectCurrentUser);
  const { navigation, postId } = useParams<{ navigation: string; postId: string; }>();
  const fellowshipPosts = useSelector(SelectPosts);
  const post = useSelector(SelectPost(postId));
  const [commentInputText, setCommentInputText] = useState('');
  const [toastMessageFailed, setToastMessageFailed] = useState('');
  const [displayToastFailed, setDisplayToastFailed] = useState(false);
  const [showCommentMenu, setShowCommentMenu] = useState(false);
  const [commentMenuEvent, setCommentMenuEvent] = useState<Event | undefined>(undefined);
  const [activeComment, setActiveComment] = useState<IFellowshipComment | undefined>(undefined);
  const textArea = useRef<HTMLIonTextareaElement>(null);
  const commentHeader = useRef<HTMLDivElement>(null);
  const commentsContentContainer = useRef<HTMLIonContentElement>(null);
  const [presentAlert] = useIonAlert();
  const networkConnected = useSelector(SelectNetworkConnected);

  useIonViewDidEnter(() => {
    switch(navigation) {
      case 'add-comment':
        textArea.current?.setFocus();
        const delayTimer = window.setInterval(() => {
          window.clearInterval(delayTimer);
          scrollToCommentBottom();
        }, 500);
        
      break;
      case 'read-comments':
        //commentHeader.current?.scrollIntoView({behavior: "smooth", block: "start"});
        const delayTimer2 = window.setInterval(() => {
          window.clearInterval(delayTimer2);
          scrollToCommentBottom();
        }, 500);
      break;
      case 'read-post':
        commentsContentContainer.current?.scrollToTop(400);
      break;
    }

    // Check for updates and update cache if different from cloud
    if(post && !post?.subscribed) {
      dbService?.getUpdatedPost(post).then(result => {
        if(result.Success) {
          if(result.Data?.modifiedDate && post.modifiedDate < result.Data?.modifiedDate)
          { 
            const updatedPost = {...result.Data, subscribed: false};
            console.log('Unsubscribed Post Updated', updatedPost);
            // Update the post in redux
            dispatch(UpdatePosts([updatedPost]));

            // Update local post cache
            FellowshipPostService.updateFellowshipPosts([{...DateHelperService.convertNumbersToDates(updatedPost)}]);

            // If post was removed go back to fellowship page
            if(updatedPost.hidden)
            {
              history.push(AppRouteInfo[AppRouteKeys.Fellowship].path, {direction: 'backward'});
            }
          }
        }
      }); 
    }
  });

  useEffect(() => {
    commentsContentContainer.current?.scrollToBottom(400);
  }, [post])

  const scrollToCommentBottom = () => {
    commentsContentContainer.current?.scrollToBottom(400);
  }

  const styleSelector = (postType: PostTypesValues | undefined) => {
    switch(postType) {
      case PostTypes.bible :
        return 'bible-post-comments';
      case PostTypes.prayer :
        return 'prayer-post-comments';
      case PostTypes.fellowship :
        return 'fellowship-post-comments';
    }
  }

  const postComment = async (post: IFellowshipPost) => {
    let currentPost = post;
    
    if(commentInputText && networkConnected) {
      const newComment: IFellowshipComment = {
        id: Date.now().toString(),
        userId: currentUser.id,
        displayName: currentUser.displayName!,
        commentText: commentInputText,
        likesTotal: 0,
        createdDate: new Date(Date.now()),
      }
      
      const addedComments = currentPost.comments?.length ? [...currentPost.comments, newComment] : [newComment];
      const updatedPost = {...currentPost, comments: addedComments}
      if(fellowshipPosts.findIndex(indexedPost => indexedPost.id === post.id) > 5) {
        // If it is an old post, then pull it back to the top when it gets a new comment.
        // Note: This will only pull it to the top on a app refresh (because of FellowshipSlice.ts)
        // which keeps the posts from jumping around when a user is reading them.
        updatedPost.sortDate = new Date(Date.now());
      }
      dbService?.updatePost(updatedPost).then(result => {
        if(result.Success) {
          setCommentInputText('');
        } else {
          setToastMessageFailed('Error: Failed to Post Comment.');
          setDisplayToastFailed(true);
        }
      })
    } else if(!networkConnected) {
      setToastMessageFailed('NO INTERNET CONNECTION DETECTED - Connection is required to comment on a post.');
      setDisplayToastFailed(true);
    }
  }

  const removeComment = async (activePost?: IFellowshipPost, activeComment?: IFellowshipComment) => {
    let currentPost = activePost;
    
    if(activePost && activeComment && networkConnected) {
      
      const updatedComment = {...activeComment};
      
      if(updatedComment && updatedComment.userId === currentUser.id)
        {
          updatedComment.commentText = '';
          updatedComment.hidden = UserRoles.groupMember;
          updatedComment.modifiedDate = new Date(Date.now());
        }
      else if(updatedComment && GetMemberInfo(currentUser.id, memberDetails, 'role') === UserRoles.admin)
        {
          updatedComment.hidden = UserRoles.admin;
          updatedComment.modifiedDate = new Date(Date.now());
        }
      
      if(updatedComment && currentPost) {
        const updatedComments = currentPost.comments.map(comment => 
          comment.id === updatedComment?.id ? updatedComment : comment
        );
        const updatedPost = {...currentPost, comments: updatedComments}
        if(fellowshipPosts.findIndex(indexedPost => indexedPost.id === activePost?.id) > 5) {
          // If it is an old post, then pull it back to the top when it gets a new comment.
          // Note: This will only pull it to the top on a app refresh (because of FellowshipSlice.ts)
          // which keeps the posts from jumping around when a user is reading them.
          updatedPost.sortDate = new Date(Date.now());
        }
        dbService?.updatePost(updatedPost).then(result => {
          if(result.Success) {
            // comment will disappear if successful
          } else {
            setToastMessageFailed('Error: Failed to Remove Comment.');
            setDisplayToastFailed(true);
          }
        })
      }
    } else if(!networkConnected) {
      setToastMessageFailed('NO INTERNET CONNECTION DETECTED - Connection is required to comment on a post.');
      setDisplayToastFailed(true);
    }
    setActiveComment(undefined);
  }

  const linkifyText = (text: string) => {
    return <Fragment>
      {text
        .split(/(https?:\/\/[\w!\?/\+\-_~=;\.,\*&@#\$%\(\)'\[\]]+)/)
        .map((v, i) =>
          i & 1 ? (
            <a className="cursor-pointer" key={i} onClick={() => navigateToLink(v, true)} >
              {v}
            </a>
          ) : (
            v
          )
        )}
    </Fragment>
  }

  const navigateToLink = (url: string, verify?: boolean) => {
    if(verify){
      const whiteList: RegExp[] = [
        // Zoom Meeting
        /^https:\/\/[\w-]*\.?zoom.us\/(j|my)\/[\d\w?=-]+/,
        // YouTube Video
        /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu\.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/,
        // Google Meet
        /^https:\/\/meet.google.com\/[\d\w-]+/,
        // Bible Study Together App
        /^https:\/\/app\.biblestudytogether.com.*/,
        // Bible Study Together
        /^https:\/\/biblestudytogether.com.*/,
      ];

      const result =  whiteList.find(regex => url.match(regex)?.length);
      console.log(result, url.match(whiteList[1]));
      if(result) {
        window.open(url);
      } else {
        presentAlert({
          header: 'NOTICE: OPENING LINK',
          message: 'You have clicked on a link to an external site shared by a group member. If you are unfamiliar with the site or the user who posted it please proceed with caution. Do you trust this link and want to open it in a browser window?',
          buttons: [
            {
              text: 'NO',
              role: 'cancel',
              handler: () => {},
            },
            {
              text: 'YES',
              role: 'confirm',
              handler: () => {
                navigateToLink(url);
              },
            },
          ],
          onDidDismiss: (e: CustomEvent) => console.log('Dismissed')});
      }

    } else {
      window.open(url);
    }
  }

  return (
    <IonPage className={styleSelector(post?.type)}>
      <PageHeader {...props} showBackButton={true} ></PageHeader>
      <IonContent ref={commentsContentContainer}>
        <IonGrid fixed={true} className="comment-page-grid">
          <IonRow >
            <IonCol className="comment-list-container">
              
              <h2 className="comment-post-title-text">{post?.title}</h2>
              <div ref={commentHeader} className="comment-post-author">
                <div className="comment-box-author">{GetMemberInfo(post?.userId, memberDetails, 'displayName')}</div>
                <div className="comment-box-date">{new Date(post?.createdDate!).toLocaleString()}</div>
              </div>

              <p className="comment-post-body">
                {post?.postText.split('\n').map((item, index) => {
                  return <span key={index}>{linkifyText(item)}</span>
                  })}
              </p>
              <PostVideos 
                postText={post?.postText} 
                showEmbed={true} 
                cssClass={'comment-post-video-container'}
                scrollToBottom={scrollToCommentBottom}></PostVideos>
              <div ref={commentHeader} className="comment-header">
                COMMENTS
              </div>
              { 
                post?.comments?.length ?
                  post.comments.map(comment => 
                    <div key={`comment-${comment.id}`} className="comment-container" hidden={
                      (currentUser.id !== comment.userId && comment.hidden === UserRoles.admin) || comment.hidden === UserRoles.groupMember ? true : false}>
                      <div className="comment-box-info">
                        <div className="comment-box-author">{GetMemberInfo(comment.userId, memberDetails, 'displayName')}</div>
                        <div className="comment-box-date">{new Date(comment.createdDate).toLocaleString()}</div>
                        <div className="comment-box-options">
                          {(currentUser.id === comment.userId || GetMemberInfo(currentUser.id, memberDetails, 'role') === UserRoles.admin) && 
                            <IonIcon icon={ellipsisVertical} onClick={(e) => { setShowCommentMenu(true); setCommentMenuEvent(e.nativeEvent); setActiveComment(comment)}}></IonIcon> }
                        </div>
                      </div>
                      <div className="comment-box">
                        {comment.commentText.split('\n').map((item, index, array) => {
                          return <span key={index}>{linkifyText(item)} {array.length !== (index +1) && <br/>}</span>
                        })}
                        <PostVideos postText={comment.commentText} cssClass={'comment-comment-post-video-container'}></PostVideos>
                      </div>
                    </div>
                ) : 
                  <div className="no-comments-container">
                    NO COMMENTS ON THIS POST
                  </div>
              }
            </IonCol>
          </IonRow>
        </IonGrid>

      </IonContent>
      <IonFooter mode="md">
        <IonGrid fixed={true} className="comment-page-grid comment-page-footer">
          <IonRow>
            <IonCol className="comment-textarea-col">
                <IonTextarea ref={textArea} value={commentInputText} aria-label="Enter Your Comment"
                  className="comment-text-area" 
                  placeholder="Enter Your Comment..."
                  autoCapitalize='sentences'
                  autoGrow={true} 
                  onIonInput={e => setCommentInputText(e.detail.value?.toString()!)}>
                </IonTextarea>
            </IonCol>
            <IonCol className="comment-submit-button-container">
              <IonButton fill="clear" onClick={() => post && postComment(post)} >
                <IonIcon icon={send}/>
              </IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonFooter>
        <IonToast color="danger"
          isOpen={displayToastFailed}
          onDidDismiss={() => setDisplayToastFailed(false)}
          message={toastMessageFailed}
          duration={2500} />
        <NetworkNotification noInternetMessage="NO INTERNET CONNECTION DETECTED - Connection is required to comment on a post."></NetworkNotification>
        <IonPopover
          mode="md"
          isOpen={showCommentMenu}
          event={commentMenuEvent}
          dismissOnSelect={true}
          onDidDismiss={() => {
              setShowCommentMenu(false); 
              setCommentMenuEvent(undefined);
              setActiveComment(undefined);
          }}
      > 
        <IonList lines="none">
          <IonItem className="cursor-pointer" onClick={() => removeComment(post, activeComment)}>
            <IonIcon icon={trashBin} slot="start"></IonIcon>
            <IonLabel>REMOVE COMMENT</IonLabel>
          </IonItem>
        { currentUser.id === activeComment?.userId && false &&
          <IonItem className="cursor-pointer"
            onClick={() => {console.log('Edit comment:', activeComment)}}>
            <IonIcon icon={chatboxEllipses} slot="start"></IonIcon>
            <IonLabel>EDIT COMMENT</IonLabel>
          </IonItem> }
        </IonList>
      </IonPopover>
    </IonPage>
  );
};

export default FellowshipCommentsPage;